import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      name: window.localStorage.getItem('user' || '[]') == null ? '未登录' : JSON.parse(window.localStorage.getItem('user' || '[]')).name,
      role: window.localStorage.getItem('user' || '[]') == null ? '' : JSON.parse(window.localStorage.getItem('user' || '[]')).role,
      phone: window.localStorage.getItem('user' || '[]') == null ? '' : JSON.parse(window.localStorage.getItem('user' || '[]')).phone,
      Id: window.localStorage.getItem('user' || '[]') == null ? '' : JSON.parse(window.localStorage.getItem('user' || '[]')).id,
      userface: window.localStorage.getItem('user' || '[]') == null ? '' : JSON.parse(window.localStorage.getItem('user' || '[]')).userface,
    },
    routes: [],
    msgList: [],
    isDotMap: new Map(),
    currentFriend: {},
    nfDot: false
  },
  mutations: {
    initMenu(state, menus) {
      state.routes = menus;
    },
    login(state, user) {
      state.user = user;
      console.log("user:" + user.toString());
      window.localStorage.setItem('user', JSON.stringify(user));
    },
    logout(state) {
      window.localStorage.removeItem('user');
      state.routes = [];
    },
    toggleNFDot(state, newValue) {
      state.nfDot = newValue;
    },
    updateMsgList(state, newMsgList) {
      state.msgList = newMsgList;
    },
    updateCurrentFriend(state, newFriend) {
      state.currentFriend = newFriend;
    },
    addValue2DotMap(state, key) {
      state.isDotMap.set(key, "您有未读消息")
    },
    removeValueDotMap(state, key) {
      state.isDotMap.delete(key);
    }
  },
  actions: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js